module.exports = __webpack_public_path__ + "static/media/YM03_1.c51c12a8.jpg";